import { useEffect, useState } from "react";
import dataProvider from "../../providers/data-provider";
import { ExternalServiceRequestAgreement } from "./external-service-request-agreement";
import { ESRConfirmationPage } from "./external-service-request-confirmation";
import { ExternalServiceRequestForm } from "./external-service-request-form";

const ExternalServiceRequestPage = (props) => {

    const { uuid, slug } = props.match.params

    const [step, setStep] = useState(0)
    const [created, setCreated] = useState(undefined)
    const [esr, setESR] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        (async () => {
            setLoading(true)
            const res = await dataProvider.get('external-service-requests', `guest/${uuid}`)
            setESR(res.data)
            setLoading(false)
        })()
    }, [uuid])

    switch (step) {
        case 0:
        default:
            return <ExternalServiceRequestAgreement esr={esr} loading={loading} setStep={setStep} />
        case 1:
            return <ExternalServiceRequestForm esr={esr} slug={slug} setStep={setStep} setCreated={setCreated} />
        case 2:
            return <ESRConfirmationPage created={created} />
    }
}


export { ExternalServiceRequestPage };
